//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import ImageViewer from '../../components/Images/ImageViewer.vue'

export default {
  components: {
    ImageViewer: ImageViewer
  },
  props: {
    reportRoadsTitle: {
      type: String,
      default: ''
    },
    reportRoadsImages: {
      type: Array,
      default () {
        return []
      }
    },
    reportRoadsTransmitted: {
      type: Boolean,
      default: false
    },
    reportRoadsTransmittedByEmail: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      filesToUpload: [],
      reportRoadsImagesLocal: []
    }
  },
  watch: {
    reportRoadsImages: function (result) {
      this.reportRoadsImagesLocal = result
    }
  },
  created: function () {
    this.reportRoadsImagesLocal = this.reportRoadsImages
  },
  methods: {
    onAddFiles: function () {
      this.$refs.uploadImages.click()
    },
    addFilesToUpload: function (event) {
      const newFiles = event.target.files

      for (let i = 0; i < newFiles.length; i++) {
        const file = newFiles[i]
        file.blob = ''
        const URL = window.URL || window.webkitURL
        if (URL && URL.createObjectURL) {
          file.blob = URL.createObjectURL(file)
        }

        file.thumb = ''
        if (file.blob && file.type.substr(0, 6) === 'image/') {
          file.thumb = file.blob
        }

        this.filesToUpload.push(file)
      }

      this.$emit('files-to-upload-changed', this.filesToUpload)
    },
    onDownloadImages: function () {
      this.downloadFileByURI('/service/fileobj/loadfiles?id=' + this.getReportRoadsImagesIds(), 'Фото по ' + this.reportRoadsTitle)
    },
    getReportRoadsImagesIds: function () {
      let resultStr = ''

      for (let i = 0; i < this.reportRoadsImages.length; i++) {
        const document = this.reportRoadsImages[i]
        resultStr += document.id

        if (i != (this.reportRoadsImages.length - 1)) {
          resultStr += ','
        }
      }

      return resultStr
    },
    downloadFileByURI: function (uri, name) {
      const link = document.createElement('a')
      link.setAttribute('download', name)
      link.href = uri
      document.body.appendChild(link)
      link.click()
      link.remove()
    },
    getBackgroundImageStyle: function (image) {
      return 'background-image: url("' +
             (image.thumb || image.url) +
             '"); background-size: cover; background-position: 50%;'
    },
    onShowPreview: function (images, index) {
      this.$refs.viewer.show(images, index)
    },
    selectOrDeleteImage: function (image) {
      const deleteImage = this.reportRoadsImagesLocal
        .map(image => image.id)
        .includes(image.id)

      if (!deleteImage) {
        this.reportRoadsImagesLocal.push(image)
      } else {
        this.reportRoadsImagesLocal = this.reportRoadsImagesLocal
          .filter(img => img.id !== image.id)
      }

      this.$emit('images-selection-changed', this.reportRoadsImagesLocal)
    },
    deleteFileFromFilesToUpload: function (index) {
      this.filesToUpload.splice(index, 1)
      this.$emit('files-to-upload-changed', this.filesToUpload)
    }
  }
}

